var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSecureLockColour = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1545_29872)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35693 13.7328H22.6447C22.9037 13.7328 23.1521 13.8357 23.3352 14.0188C23.5184 14.2019 23.6213 14.4503 23.6213 14.7093V25.0251C23.6213 25.2841 23.5184 25.5325 23.3352 25.7156C23.1521 25.8988 22.9037 26.0016 22.6447 26.0016H9.35693C9.09793 26.0016 8.84954 25.8988 8.6664 25.7156C8.48326 25.5325 8.38037 25.2841 8.38037 25.0251V14.7077C8.38037 14.4487 8.48326 14.2003 8.6664 14.0172C8.84954 13.834 9.09793 13.7311 9.35693 13.7311V13.7328Z",
    fill: "#FBD734"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1984 20.528L14.1454 23.2868H17.8547L16.8781 20.4857C17.2638 20.2867 17.5706 19.9628 17.7485 19.5669C17.9264 19.171 17.9648 18.7265 17.8575 18.306C17.7503 17.8854 17.5036 17.5137 17.1578 17.2514C16.8119 16.9892 16.3874 16.8519 15.9536 16.862C15.5197 16.8721 15.102 17.0289 14.7688 17.307C14.4355 17.5851 14.2064 17.9679 14.1187 18.3929C14.0311 18.818 14.0902 19.2602 14.2863 19.6474C14.4824 20.0346 14.8039 20.3439 15.1984 20.5248V20.528Z",
    fill: "#36464E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9822 13.7328H20.1349V12.1996C20.1414 11.0488 19.7015 9.94028 18.9077 9.10711C18.536 8.70758 18.086 8.38894 17.5857 8.17105C17.0854 7.95317 16.5456 7.84072 16 7.84072C15.4543 7.84072 14.9145 7.95317 14.4142 8.17105C13.9139 8.38894 13.4639 8.70758 13.0923 9.10711C12.2984 9.94028 11.8585 11.0488 11.865 12.1996V13.7328H10.0177V12.1996C10.0151 10.5745 10.6402 9.01121 11.7625 7.83595C12.3058 7.25653 12.9621 6.7947 13.691 6.47898C14.4198 6.16326 15.2057 6.00037 16 6.00037C16.7943 6.00037 17.5801 6.16326 18.3089 6.47898C19.0378 6.7947 19.6941 7.25653 20.2374 7.83595C21.3606 9.01065 21.9858 10.5743 21.9822 12.1996V13.7328V13.7328Z",
    fill: "#36464E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1545_29872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2393,
    height: 20,
    fill: "white",
    transform: "translate(8.38037 6)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSecureLockColour);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/secure-lock-colour.f1e098d6f80a7f0a4779c092dbb3123a.svg";